import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getFilters } from '../selectors/filtersSelectors';
import { setQueryParams } from '../utils/filters';
import { ANALYZE_ROUTE } from '../constants/Tabs';
import { buildTypedMap } from '../types/TypedMap';
export const useQueryParams = () => {
  const history = useHistory();
  const location = useLocation();
  const isDetail = location.pathname.includes('/owner/');
  const isAnalyze = location.pathname.includes(ANALYZE_ROUTE);
  const filters = useSelector(getFilters);
  const analyzeFilters = useMemo(() => buildTypedMap({
    pipeline: filters.get('pipeline')
  }), [filters]);
  const filtersToSet = isAnalyze ? analyzeFilters : filters;
  useEffect(() => {
    setQueryParams({
      history,
      filters: filtersToSet,
      setDealGroupingParams: isDetail
    });
  }, [isDetail, filtersToSet, history]);
};